import { ListItem, ListItemsWrapper } from "@fluidattacks/design";
import { useTranslation } from "react-i18next";

interface IEntryConfigMenuProps {
  isVisible: boolean;
  onOpenUpdateEntryModal: () => void;
  onOpenSetEntryAsSubentryModal: () => void;
  onOpenDeleteEntryModal: () => void;
  onOpenMoveEntryWithSubentriesModal: () => void;
}

export const EntryConfigMenu = ({
  isVisible,
  onOpenUpdateEntryModal,
  onOpenSetEntryAsSubentryModal,
  onOpenDeleteEntryModal,
  onOpenMoveEntryWithSubentriesModal,
}: IEntryConfigMenuProps): JSX.Element | undefined => {
  const { t } = useTranslation();

  if (!isVisible) {
    return undefined;
  }

  return (
    <ListItemsWrapper>
      <ListItem
        icon={"pencil"}
        iconType={"fa-light"}
        onClick={onOpenUpdateEntryModal}
      >
        {t("mailmap.updateEntry")}
      </ListItem>
      <ListItem
        icon={"money-check-pen"}
        iconType={"fa-light"}
        onClick={onOpenSetEntryAsSubentryModal}
      >
        {t("mailmap.setEntryAsSubentry")}
      </ListItem>
      <ListItem
        icon={"trash"}
        iconType={"fa-light"}
        onClick={onOpenDeleteEntryModal}
      >
        {t("mailmap.deleteEntry")}
      </ListItem>
      <ListItem
        icon={"share-from-square"}
        iconType={"fa-light"}
        onClick={onOpenMoveEntryWithSubentriesModal}
      >
        {t("mailmap.moveEntryWithSubentries")}
      </ListItem>
    </ListItemsWrapper>
  );
};
